import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { isNotEmpty } from './store/utils'
import vuetify from './plugins/vuetify'

// eigene Styleanpassungen
import './assets/css/layout.css'

// cookies
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

// popover
import { PopoverPlugin } from 'bootstrap-vue'
Vue.use(PopoverPlugin)

// moment
import moment from 'moment-feiertage'
import 'moment/locale/de'
moment.locale('de')
Vue.prototype.moment = moment

// editor
import CKEditor from '@ckeditor/ckeditor5-vue2'
Vue.use(CKEditor)

// apexchart
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

// Excel export
import VueExcelEditor from 'vue-excel-editor'
Vue.use(VueExcelEditor)

// Http-Requests
import axios from 'axios'
// Store requests
let sourceRequest = {}
// config axios
const axiosConfig = {
  baseURL: process.env.VUE_APP_HOME + 'api/',
  timeout: 1200000,
  headers: {
    Authorization: sessionStorage.getItem('apiToken'),
  },
}

Vue.prototype.$axios = axios.create(axiosConfig)

Vue.prototype.$axios.interceptors.request.use(
  (request) => {
    var cancelURL = request.method + '->' + request.url

    request.config = {
      ...(request.config ?? {}), // preserve a given request.config object
      start: Date.now(),
      cancelURL: cancelURL,
    }

    // If the application exists cancel
    if (sourceRequest[cancelURL]) {
      sourceRequest[cancelURL].cancel('Automatic cancellation')
      console.log(`Request cancelled "${request.method}->${request.url}"`)
    }

    // Store or update application token
    const axiosSource = axios.CancelToken.source()
    sourceRequest[cancelURL] = { cancel: axiosSource.cancel }
    request.cancelToken = axiosSource.token

    if (
      !store.state.doNotShowLoading.includes(request.url) &&
      !request.url.match(new RegExp(store.state.doNotMatch.join('|')))
    )
      store.commit('setLoading', true)

    return request
  },
  (error) => {
    if (error.response) console.error(error.response)
    return Promise.reject(error)
  }
)

Vue.prototype.$axios.interceptors.response.use(
  (response) => {
    const now = Date.now()
    const duration = now - response.config.config.start
    delete sourceRequest[response.config.config.cancelURL]

    console.info(
      `Api Call "${response.config.method}->${response.config.url}" took ${duration}ms. Response => `,
      response.data
    )
    document.getElementById('footer-info').innerHTML = `last API call took ${
      duration / 1000
    }s`

    // fill searchHIstory
    if (store.getters.searchField != '' && isNotEmpty(response.data))
      store.commit('setSearchHistory', store.getters.searchField)

    store.commit('setLoading', false)

    return response
  },
  (error) => {
    if (error.response) console.warn(error.response.data)

    document.getElementById('footer-info').innerHTML = `API ERROR`
    store.commit('setLoading', false)

    return Promise.reject(error)
  }
)

// search highlighting
Vue.prototype.highlight = function (content, searchTerm) {
  if (!searchTerm || !content) return content
  else {
    // for multi key search
    const searchWords = searchTerm.trim().split(/\s+/).join('|')
    // search = search
    //   .split('+')
    //   .map((s) => s.trim())
    //   .join('|')

    // search without html tags
    return content
      .toString()
      .replace(
        new RegExp(
          '(?:<[^>]*>)|(' + searchWords.replace(/[?()[\]\\]/g, '\\$&') + ')',
          'gi'
        ),
        (match, group) =>
          group ? '<span class="highlight">' + group + '</span>' : match
      )
  }
}

// global components
Vue.component('MyMessage', () => import('./components/Message'))
Vue.component('SearchMessage', () => import('./components/SearchMessage'))

// filter
Vue.filter('FULLNAME', function (userId) {
  return store.getters.FULLNAME(userId)
})

Vue.filter('INITIALS', function (userId) {
  return store.getters.INITIALS(userId)
})

Vue.filter('AVATAR', function (userId) {
  return store.getters.AVATAR(userId)
})

Vue.filter('CURRENCY', function (val) {
  return store.getters.CURRENCY(val)
})

Vue.filter('DECIMAL', function (val) {
  return store.getters.DECIMAL(val)
})

Vue.filter('FILESIZE', function (val) {
  return store.getters.FILESIZE(val)
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app')
